import { Button, Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { Container } from 'src/components/container';
import { breakpointTablet } from 'src/styles/breakpoints';
import { spacing2, spacing3, spacing4, spacing5, spacing7, spacing8, spacing9 } from 'src/styles/spacing';

export const StyledContainer = styled(Container)`
  margin-top: ${spacing2};
  margin-bottom: ${spacing7};

  @media (min-width: ${breakpointTablet}) {
    margin-top: ${spacing5};
    margin-bottom: ${spacing9};
  }
`;

export const StyledHeading = styled(Typography)`
  text-align: center;
  margin-bottom: ${spacing7};
`;

export const StyledButton = styled(Button)`
  margin: ${spacing4} auto ${spacing3};

  @media (min-width: ${breakpointTablet}) {
    margin: ${spacing8} auto ${spacing3};
  }
`;

export const StyledTerms = styled(Typography)`
  text-align: center;
`;
